import { useCallback } from 'react';
import { useTranslations } from 'js/hooks/i18n';
import { useGetPlayerTags, useGetTwoFactorConf } from 'server';

export const useGetTitleAsync = () => {
    const translate = useTranslations('playtech.mobile.system.2FA.popup.');
    const getPlayerTags = useGetPlayerTags();
    const getTwoFactorConf = useGetTwoFactorConf();

    const getPlayerChannel = useCallback(async () => {
        const { tags: [tag] = [] } = await getPlayerTags({ tagName: 'uam/2fa/2FAChannel' });

        return tag?.value?.toLowerCase();
    }, [getPlayerTags]);

    const getDefaultChannel = useCallback(async () => {
        const response = await getTwoFactorConf();

        return response?.data?.twoFactorConf?.defaultChannel?.toLowerCase();
    }, [getTwoFactorConf]);

    return useCallback(async () => {
        try {
            switch (await getPlayerChannel()) {
                case 'sms': return translate('title.SMS');
                case 'email': return translate('title.email');
                default: break;
            }

            switch (await getDefaultChannel()) {
                case 'sms': return translate('title.SMS');
                case 'email': return translate('title.email');
                default: break;
            }

            return translate('title.default');
        } catch (error) {
            return translate('title.default');
        }
    }, [getDefaultChannel, getPlayerChannel, translate]);
};
